import React, { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import axiosInstance, { EVENT_ID, WEB_API } from '../constatns';
import CssBaseline from '@material-ui/core/CssBaseline';
import queryString from 'query-string';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
    '& p': {
      display: 'inline',
    },
  },
  idBox: {
    border: '1px solid #000',
    padding: 10,
    fontWeight: 'bold',
  },
}));

const SpeakerPreviewAdmin = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [ti1, setTi1] = useState();

  const type = queryString.parse(props.location.search)['type'];
  const getSpeakerData = () => {
    console.log('getSpeakerData >>>');
    const speakerId = props.location ? queryString.parse(props.location.search)['speakerId'] : null;
    if (speakerId) {
      axiosInstance
        .get(`${WEB_API}/speaker/info?eventId=${EVENT_ID}&speakerId=${speakerId}`, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          // console.log(response.data.Item);
          setData([response.data.Item]);
        });
    } else {
      axiosInstance.get(`${WEB_API}/speaker/list?eventId=${EVENT_ID}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
        // console.log(response.data);
        setData(response.data);
      });
    }
  };

  useEffect(() => {
    getSpeakerData();
    if (type === 'download') {
      const _ti1 = setTimeout(() => {
        doDown();
      }, 1000);
      setTi1(_ti1);
    }
    return () => {
      clearTimeout(ti1);
    };
  }, []);

  const doDown = () => {
    const preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    const postHtml = '</body></html>';
    const html = preHtml + document.getElementById('subroot').innerHTML + postHtml;
    const blob = new Blob(['\ufeff', html], {
      type: 'application/msword',
    });
    const url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    const filename = 'SpeakerAbstract_word.doc';
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.click();
    }
    document.body.removeChild(downloadLink);

    window.opener = 'Self';
    window.open('', '_parent', '');
    window.close(); // 일반적인 현재 창 닫기
    window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
  };

  return (
    <Grid container className={classes.root} style={type === 'download' ? { visibility: 'hidden' } : { visibility: 'visible' }}>
      <CssBaseline />
      {data.map((item, idx) => {
        return (
          <Grid container key={'paper-preview-' + idx}>
            <Grid item xs={12} className={classes.idBox}>
              [{item.speakerRegNo}]
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <h2>{item.noteTitle}</h2>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              {item.firstName} {item.lastName}
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center', marginBottom: 20 }}>
              {item.affiliation}
            </Grid>
            <Grid item xs={12}>
              <div
                dangerouslySetInnerHTML={{
                  __html: '<div style="display: inline;" ><b>body: </b> ' + item.noteContent.replace(/\n/g, '<br/>') + '</div>',
                }}
              />
            </Grid>

            <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
              {item.figures1 && <img alt={'figures1'} src={item.figures1.path} style={{ maxWidth: '100%' }} />}
            </Grid>
            <Grid item xs={12} style={{ marginBottom: 10 }}>
              {item.figures2 && <img alt={'figures1'} src={item.figures2.path} style={{ maxWidth: '100%' }} />}
            </Grid>
            <Grid item xs={12} style={{ marginBottom: 10 }}>
              {item.figures3 && <img alt={'figures1'} src={item.figures3.path} style={{ maxWidth: '100%' }} />}
            </Grid>
            <Grid item xs={12} style={{ marginBottom: 10 }}>
              {item.figures4 && <img alt={'figures1'} src={item.figures4.path} style={{ maxWidth: '100%' }} />}
            </Grid>
            <Grid item xs={12} style={{ marginBottom: 10 }}>
              {item.figures5 && <img alt={'figures1'} src={item.figures5.path} style={{ maxWidth: '100%' }} />}
            </Grid>
            <Grid item xs={12} style={{ marginBottom: 10 }}>
              {item.figures6 && <img alt={'figures1'} src={item.figures6.path} style={{ maxWidth: '100%' }} />}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SpeakerPreviewAdmin;
